"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = void 0;
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../../mantine-hooks/src");
var ActionIcon_1 = require("../ActionIcon/ActionIcon");
var TextInput_1 = require("../TextInput/TextInput");
var PasswordToggleIcon_1 = require("./PasswordToggleIcon");
function PasswordInput(_a) {
    var radius = _a.radius, disabled = _a.disabled, hidePasswordLabel = _a.hidePasswordLabel, showPasswordLabel = _a.showPasswordLabel, themeOverride = _a.themeOverride, _b = _a.focusInputOnToggle, focusInputOnToggle = _b === void 0 ? false : _b, elementRef = _a.elementRef, others = __rest(_a, ["radius", "disabled", "hidePasswordLabel", "showPasswordLabel", "themeOverride", "focusInputOnToggle", "elementRef"]);
    var inputRef = react_1.useRef();
    var _c = react_1.useState(false), reveal = _c[0], setReveal = _c[1];
    var toggleReveal = function () {
        setReveal(function (current) { return !current; });
        if (focusInputOnToggle) {
            inputRef.current.focus();
        }
    };
    var rightSection = (react_1.default.createElement(ActionIcon_1.ActionIcon, { onClick: toggleReveal, themeOverride: themeOverride, title: reveal ? hidePasswordLabel : showPasswordLabel, "aria-label": reveal ? hidePasswordLabel : showPasswordLabel, radius: radius },
        react_1.default.createElement(PasswordToggleIcon_1.PasswordToggleIcon, { reveal: reveal })));
    return (react_1.default.createElement(TextInput_1.TextInput, __assign({}, others, { disabled: disabled, themeOverride: themeOverride, elementRef: hooks_1.useMergedRef(inputRef, elementRef), type: reveal ? 'text' : 'password', rightSection: disabled ? null : rightSection, radius: radius })));
}
exports.PasswordInput = PasswordInput;
PasswordInput.displayName = '@mantine/core/PasswordInput';
